/**
 * Portal V2 admin gate — UI only for whitelisted Exigo customer IDs.
 * Does not affect classic (V1) routes or menus.
 */

/** Exigo customer IDs allowed to see Lab / admin tools in Dashboard V2 */
export const V2_ADMIN_EXIGO_IDS = [19113609, 3635];

export function isV2Admin(exigoUserId) {
    const id = Number(exigoUserId);
    if (!Number.isFinite(id) || id <= 0) return false;
    return V2_ADMIN_EXIGO_IDS.includes(id);
}

/**
 * Resolve Exigo id from a checkUserSession() payload (field names vary by login path).
 */
export function getExigoUserIdFromSession(session) {
    if (!session || typeof session !== 'object') return null;
    const raw =
        session.exigoCustomerId ??
        session.ExigoCustomerId ??
        session.exigoUserId ??
        session.ExigoUserId ??
        session.userId ??
        session.UserId;
    const id = Number(raw);
    if (!Number.isFinite(id) || id <= 0) return null;
    return id;
}

export function isV2AdminSession(session) {
    return isV2Admin(getExigoUserIdFromSession(session));
}
